"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var roleHandlers;
    (function (roleHandlers) {
        /** The role handler for controls */
        var Control = /** @class */ (function (_super) {
            __extends(Control, _super);
            function Control(targetElement, roleName) {
                var _this = _super.call(this, targetElement) || this;
                _this.type = roleName;
                return _this;
            }
            /**
             * Performs actual data-binding when the control template is resolved
             */
            Control.prototype.dataBind = function (dataContext, onDataBindComplete, virtualInstance, shadowedContext) {
                var _this = this;
                if (this.context) {
                    $dyn.logError("Rebind called: %o", this);
                    return;
                }
                this.shadowedContext = shadowedContext;
                this.parentContext = dataContext;
                var dataBindIfResolved = function () {
                    _this.loadTemplate();
                    _this.doDataBinding(dataContext, virtualInstance);
                    if (onDataBindComplete) {
                        onDataBindComplete();
                    }
                };
                if (this.targetElement.classList.contains("unresolved")) {
                    // Save the resolve action to resume data-binding when the template has been resolved
                    this.targetElement[$dyn.Const.templateResolveAction] = dataBindIfResolved;
                }
                else {
                    dataBindIfResolved();
                }
            };
            /**
             * Initialize and create the control based on the context
             */
            Control.prototype.evalDataContext = function (dataContext) {
                this._initContext(dataContext);
                this._initParameters();
                this._initName();
                var control = this.createControl(this.parameters);
                this._initId();
                this.initControl(control, this.targetElement);
                control.setUpdating(false);
                return this.context;
            };
            /**
             * Create the control
             * @param controlParameters Parameters to be passed to the control's constructor
             */
            Control.prototype.createControl = function (controlParameters) {
                if (!this.controlCtor) {
                    this.controlCtor = $dyn.ui.Control;
                    // Use the default constructor for unknown controls.  If the template is also unknown then it will be rendered using a placeholder.
                    $dyn.logError($dyn.format($dyn.label("Framework_UnknownControl"), this.type, controlParameters.Name));
                }
                var control = new this.controlCtor(controlParameters, this.targetElement, this.parentControlContext ? this.parentControlContext.current : null, this);
                if (this.context && this.context.scopeVars) {
                    var scopeVars = this.context.scopeVars;
                    scopeVars.$control = control;
                    this.context.current = control;
                }
                return control;
            };
            /**
             * Override method to handle control init.
             */
            Control.prototype.initControl = function (control, element) { };
            Control.prototype.hasBinding = function () {
                return true;
            };
            Control.prototype.dataBindChildren = function (dataContext, virtualInstance, forceBinding) {
                _super.prototype.dataBindChildren.call(this, dataContext, virtualInstance, forceBinding);
                if (this._children) {
                    this._children.valueChanged.raise();
                }
            };
            Object.defineProperty(Control.prototype, "children", {
                /**
                 * A computed that will fire if the children change
                 */
                get: function () {
                    var _this = this;
                    if (!this._children) {
                        this._children = $dyn.computed(function () {
                            var children = $dyn.children(_this.targetElement);
                            return $.map(children, function (itemElement) {
                                return $dyn.context(itemElement);
                            });
                        });
                    }
                    return this._children;
                },
                set: function (value) {
                    // This should only be used by test methods
                    this._children = value;
                },
                enumerable: false,
                configurable: true
            });
            Control.prototype.dispose = function () {
                var control = this.context && this.context.current;
                control && control.dispose && control.dispose();
                if (this.targetElement) {
                    if (this.targetElement.dynOptions) {
                        this.targetElement.dynOptions = null;
                    }
                    if (this.targetElement.dynChildren) {
                        this.targetElement.dynChildren = null;
                    }
                    if (this.targetElement.dynTemplatedParent) {
                        this.targetElement.dynTemplatedParent = null;
                    }
                }
                if (this._children) {
                    if (this._children.valueChanged && this._children.valueChanged.clearAllDependencies) {
                        this._children.valueChanged.clearAllDependencies();
                    }
                    this._children = null;
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Get and merge the template with the targetElement of the role handler
             */
            Control.prototype.loadTemplate = function () {
                this.controlCtor = $dyn.controls[this.type];
                if (!this.controlCtor) {
                    this.controlCtor = $dyn.ui.Control;
                }
                this.template = this.controlCtor.prototype.template || this.controlCtor.prototype.template === "" ? this.controlCtor.prototype.template : this.type;
                if (this.template) {
                    var templateElement = $dyn._getTemplate(this.template);
                    if (templateElement) {
                        $dyn._mergeTemplate(templateElement, this.targetElement);
                    }
                    else {
                        $dyn.logError($dyn.format($dyn.label("Framework_MissingTemplate"), this.template));
                    }
                }
            };
            /**
             * Create the control context and scopeVars
             */
            Control.prototype._initContext = function (dataContext) {
                if (this.targetElement.hasAttribute("data-dyn-context")) {
                    dataContext = $dyn.roleHandlers.Html.prototype.evalDataContext.call(this, dataContext);
                }
                if (!(dataContext instanceof $dyn.DataContext)) {
                    dataContext = new $dyn.DataContext(dataContext);
                }
                this._dataSourceContext = dataContext;
                if (this._dataSourceContext.current instanceof $dyn.ui.Control) {
                    // This control is an internal control of a template
                    this.parentControlContext = this._dataSourceContext;
                    // The parent context has the root.
                    this.root = this.parentControlContext && this.parentControlContext.scopeVars.$root;
                }
                else if (this.shadowedContext && this.shadowedContext.current) {
                    if (this.shadowedContext.current instanceof $dyn.ui.Control) {
                        // This control is a child pass to a control
                        this.parentControlContext = this.shadowedContext;
                    }
                    // The scope vars should have the root
                    this.root = this.shadowedContext.scopeVars.$root;
                }
                // Create the control context.  The current value will be filled in by createControl
                this.context = new $dyn.DataContext(null, this._dataSourceContext);
                var scopeVars = this.context.scopeVars;
                // Set the scope vars.
                if (scopeVars._dataSourceContext !== this._dataSourceContext) {
                    scopeVars._dataSourceContext = this._dataSourceContext;
                }
                if (!("$root" in scopeVars) && this.root) {
                    scopeVars.$root = this.root;
                }
            };
            /**
             * Apply the dynOptions on the targetElement and set up the parameters object
             */
            Control.prototype._initParameters = function () {
                var _this = this;
                // dynOptions will be set when the control was dynamically added
                this.parameters = this.targetElement.dynOptions;
                if (this.parameters === undefined) {
                    // Control parameters was defined in markup.
                    if (this.targetElement.hasAttribute("data-dyn-options")) {
                        var defaultEvaluator_1 = $dyn._parseDataContext(this.targetElement, "data-dyn-options");
                        if (defaultEvaluator_1) {
                            if (!$dyn.flags.observableControlOptions) {
                                this.parameters = this.targetElement.dynOptions = defaultEvaluator_1(this._dataSourceContext, this.targetElement);
                            }
                            else {
                                // Experimental support for allowing the data context to change (used by the control gallery grid).
                                $dyn.observe(function () {
                                    var value = _this._dataSourceContext.current;
                                    // Unwrap parent context to take a dependency on it and update the context for evaluation.
                                    _this._dataSourceContext.current = $dyn.value(value);
                                    var result = defaultEvaluator_1(_this._dataSourceContext, _this.targetElement);
                                    // Restore the parent context to allow for the context to be reused instead of creating a new context for the eval.
                                    _this._dataSourceContext.current = value;
                                    return result;
                                }, function (options) {
                                    if (_this.context.current) {
                                        $dyn.callFunction(_this.context.current.setUpdating, _this.context.current, true);
                                        // tslint:disable-next-line:forin
                                        for (var key in options) {
                                            // Update the context with new values from the most recent evaluation
                                            $dyn.setValue(_this.context.current, key, $dyn.value(options[key]));
                                        }
                                        $dyn.callFunction(_this.context.current.setUpdating, _this.context.current, false);
                                    }
                                    else {
                                        _this.parameters = _this.targetElement.dynOptions = options;
                                    }
                                });
                            }
                        }
                    }
                    else if ($dyn.serverForm) {
                        // TODO: Need to refactor out reference to serverForm (#1031529).
                        var serverFormParams = $dyn.serverForm.InteractionHandler.prototype.clone(this);
                        if (serverFormParams) {
                            // Control was cloned such as in a grid scenario
                            this.parameters = this.targetElement.dynOptions = serverFormParams;
                        }
                    }
                }
                if (this.parameters === undefined || this.parameters === null) {
                    // Data bindings were not used on the usage of the control on the form.
                    this.parameters = this.targetElement.dynOptions = {};
                }
                this.parameters.Root = this.root;
                this.parameters.TypeName = this.type;
                // Set up the data source
                if ("DataSource" in this.parameters) {
                    this._dataSourceContext = new $dyn.DataContext(this.parameters.DataSource, this._dataSourceContext);
                }
                else {
                    // Pass through the parent context
                    this.parameters.DataSource = this._dataSourceContext ? this._dataSourceContext.current : null;
                }
            };
            /**
             * Assign the name of the control, give a unique name if one not provided
             */
            Control.prototype._initName = function () {
                if (this.parameters.Name) {
                    this.name = this.parameters.Name;
                }
                else if (this.targetElement.hasAttribute("data-dyn-controlname")) {
                    this.name = this.parameters.Name = this.targetElement.getAttribute("data-dyn-controlname");
                }
                else {
                    this.name = this.parameters.Name = ($dyn.ui.uniqueId++).toString();
                }
            };
            /**
             * Set the id of the control
             */
            Control.prototype._initId = function () {
                var index = this.context.scopeVars.$index;
                var prevId = this.targetElement.getAttribute("id");
                // Need to check the index due to cloning done in Grids
                if (!prevId || index !== undefined) {
                    var id = void 0;
                    var rootContext_1 = this.root;
                    if (rootContext_1) {
                        var rootName = $dyn.value(rootContext_1.ObjectName) || "";
                        // Ideally this should be just the Id and the Id shouldn't change.
                        var clientId = rootContext_1.ClientId ? rootContext_1.ClientId : "";
                        id = rootName + "_" + clientId + "_" + this.name;
                        if (index !== undefined) {
                            id = id + "_" + index;
                        }
                    }
                    else {
                        id = this.name;
                    }
                    if (id && id !== prevId) {
                        this.context.current.Id = id;
                    }
                }
            };
            return Control;
        }(roleHandlers.Html));
        roleHandlers.Control = Control;
    })(roleHandlers = $dyn.roleHandlers || ($dyn.roleHandlers = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ControlRole.js.map
